import { ajax } from 'jquery/dist/jquery'
import utils from './utility'
import VueCookies from 'vue-cookies'
import url from './url'

let fetch = function(obj, obj2=null) {
    return new Promise(function(resolve, reject) {
        obj.beforeSend = function(xhr) {
            if(obj2){
                //console.log(obj2)
                if('vueScope' in obj2){
                    let view = obj2.vueScope
                    let current_active_module = view.$store.getters["RawData/getCurrentActiveModule"]
                    if(current_active_module){
                        xhr.setRequestHeader('moduleid', current_active_module.module_id);
                    }
                }
                if('operation' in obj2){
                    let operation= obj2.operation
                    xhr.setRequestHeader('operationid', operation);
                }
            }
            let user_id = utils.getCookies('user_id')
            let role_id = utils.getCookies('user_role')
            if(user_id){
                xhr.setRequestHeader('userid', user_id);
            }
            if(role_id){
                xhr.setRequestHeader('roleid', role_id);
            }
            xhr.setRequestHeader('Authorization', utils.getAccessToken());
        }
        ajax(obj).done(function (response) {
            resolve(response)
        }).fail(function (err) {
            if(err.status === 401){
                console.log("in 401")
                VueCookies.remove('access_token', null, url('DOMAIN_NAME'))
                VueCookies.set('isActive', false, null, null,url('DOMAIN_NAME'))
                if(confirm("Your session has expired, please login again")){ 
                    location.href = url('SIGNIN_URL')
                }else{
                    location.href = url('SIGNIN_URL')
                }
            }
            reject(err)
            console.log(err)
        })
    })
}

export default fetch